import axios from "../utils/axiosConfig";
const { BASE_URL } = require("../utils/urls");
const API_URL = `${BASE_URL}/api/auth`
export const getOrganizationDetails = async (orgId: string) => {
  try {
    const response = await axios.get(`${API_URL}/getOrgDetails`, {
      params: { orgId },
    });
    if (response.data.success) {
      return response.data.data[0];
    } else {
      throw new Error(
        response.data.message || "Failed to fetch organization details."
      );
    }
  } catch (error: any) {
    throw new Error(
      error.response?.data?.message || "Failed to fetch organization details."
    );
  }
};
